import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// recuperer le compte du nombre d'enseignant par annee universitaire
export const getTeacherCountByYear = async (id_academicYear) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/dashboard/teachers/${id_academicYear}`,
    {
      headers: setHeaders(),
    },
  );
  return response.data;
};

// recuperer le compte du nombre d'etudiant par annee universitaire
export const getStudentCountByYear = async (id_academicYear) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/dashboard/students/${id_academicYear}`,
    {
      headers: setHeaders(),
    },
  );
  return response.data;
};

// recuperer le compte du nombre de classe par annee universitaire
export const getClasseCountByYear = async (id_academicYear) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/dashboard/classes/${id_academicYear}`,
    {
      headers: setHeaders(),
    },
  );
  return response.data;
};

// recuperer le nombre de parent d'eleve par annee universitaire
export const getParentCountByYear = async (id_academicYear) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/dashboard/parents/${id_academicYear}`,
    {
      headers: setHeaders(),
    },
  );
  return response.data;
};

//  recuperer le compte de salle de classe par annee universitaire
export const getClassroomCountByYear = async (id_academicYear) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/dashboard/classrooms/${id_academicYear}`,
    {
      headers: setHeaders(),
    },
  );
  return response.data;
};

// recuperer les statistique du dashboard
export const getDashboardSummary = async (id_academicYear, context) => {
  const response = await axios.get(
    `${apiPaths.baseUrl}/api/dashboard/summary/${id_academicYear}`,
    {
      headers: setHeaders(context),
    },
  );
  return response.data;
};
